export default "__VITE_ASSET__Dxp4pId2__"